import { resolveRegion } from "../resolve-region/resolveRegion"

// Global Privacy Control is a legally binding opt-out: when present we honor it
// as a decline, suppressing the banner while still managing consent so the
// visitor can later override the auto-decline.
export function hasGlobalPrivacyControl(): boolean {
  return Boolean(
    (navigator as Navigator & { globalPrivacyControl?: boolean })
      .globalPrivacyControl
  )
}

// Consent is managed — and its footer controls render — whenever there is a
// stored preference the visitor can revisit: gated regions, plus any region
// where a Global Privacy Control decline needs an override path.
export function isConsentManaged(): boolean {
  return hasGlobalPrivacyControl() || resolveRegion() === "gated"
}
